import React from 'react';

import {fetchEvent} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

export default ({eventId, children}) => {
    useStoredDataChanged();
    return (
        <Loader skipSpinner={state => state.events[eventId]?.event.loaded} promises={[fetchEvent(eventId)]}>
            {children}
        </Loader>
    );
};
